
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 90 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M33.75 90a5.601 5.601 0 0 1-3.46-1.192 5.612 5.612 0 0 1-2.165-4.433V52.239L.854 8.606a5.63 5.63 0 0 1-.148-5.71A5.617 5.617 0 0 1 5.621 0h78.751a5.632 5.632 0 0 1 4.922 2.897 5.62 5.62 0 0 1-.15 5.71L61.871 52.238V78.75a5.624 5.624 0 0 1-4.265 5.456l-22.5 5.625-1.36.169h.003zM9.77 7.25l25.747 40.394a5.64 5.64 0 0 1 .854 2.981v29.543l17.25-3.812v-25.73a5.64 5.64 0 0 1 .855-2.982L79.907 7.25H9.767h.004zM28.126 46h33.75v9.25h-33.75V46z","fill":"#8296A0","fill-rule":"nonzero"}})])
      }
    
      }
    